import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateVehicle from "../pages/Vehicle/CreateVehicle";
//@ts-ignore
import {
  AccessControl,
  PermissionRequired,
  //@ts-ignore
} from "@careinfo/permission-required";
import EditVehicle from "../pages/Vehicle/EditVehicle";
import VehicleList from "../pages/Vehicle/VehicleList";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path={"/"}
            element={
              <AccessControl
                children={<VehicleList />}
                allowedPermissions={["can_view_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/vehicle"}
            element={
              <AccessControl
                children={<VehicleList />}
                allowedPermissions={["can_view_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path={"/create"}
            element={
              <AccessControl
                children={<CreateVehicle />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />

          <Route
            path={"/edit/:id"}
            element={
              <AccessControl
                children={<EditVehicle />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
